import requestHelper from "../../plugins/requestHelper";
import { toggleBox } from "../toggleBox/toggleBox";
import { approvals } from "../approvals/approvals";
import { sForm } from "../ajaxForm/ajax";
import { bindTooltip } from "../../../vendors/tooltips";
import { dropdownAnimation } from "../dropdown/dropdownAnimation";
import { eDropdown } from "../dropdown/dropdown";
import { formInputs } from "../forms/inputs";
import { attachments } from "../forms/attachment";
import { dAction } from "../dataAction/dataAction";
import { isInViewport } from "../../modules/helpers/viewport";

Vue.component("form-continuation", {
	delimiters: ["{[{", "}]}"],
	props: ["component"],
	data: function () {
		return {};
	},
	created() {},
	updated() {},
	template: "#contact-help-form-continuation",
	methods: {},
});

Vue.component("search-help", {
	delimiters: ["{[{", "}]}"],
	data: function () {
		return {
			// searchInput: '',
			// disabledSubmit: true,
			// showlinks: false,
			// fastlinks: true,
			// prompts: ''
		};
	},
	created() {},
	updated() {},
	template: "#search-help-template",
	methods: {},
});

Vue.component("contact-help-components", {
	delimiters: ["{[{", "}]}"],
	props: ["results", "level"],
	data: function () {
		return {
			// result: this.results
		};
	},
	created() {
		// console.log('contact-help-components => created: ', this.results, ' | ', this.level);
	},
	updated() {
		// console.log('contact-help-components => updated: ', this.results, ' | ', this.level);
	},
	template: "#contact-help-components",
	methods: {},
});

Vue.component("contact-help-tiles", {
	delimiters: ["{[{", "}]}"],
	props: ["results", "level", "activeProp"],
	data: function () {
		return {
			active: this.activeProp,
			// result: this.results
		};
	},
	created() {
		// console.log('contact-help-tiles => created: ', this.results, ' | ', this.level);
	},
	updated() {
		// console.log('contact-help-tiles => updated: ', this.results, ' | ', this.level);
	},
	template: "#contact-help-tiles",
	methods: {
		showHelp: function (id, guid) {
			// this.$root.showHelp(id, this.level);
			this.$emit("show-help", {
				id: id,
				guid: guid,
				level: this.level,
			});
		},
	},
});

Vue.component("help-modules", {
	delimiters: ["{[{", "}]}"],
	props: ["method", "url", "activated", "dataid"],
	data: function () {
		return {
			$rootElementComponent: null,
			results: {},
			results2: {},
			results3: {},
			idValue: [],
			idValueString: "",
			paramsArray: [],
			active: "",
			scroll: false,
			params: {},
			result_changed: false,
			res_data: null,
			viewed: false,
			filled: false,
		};
	},
	created() {},
	mounted() {
		// console.log("help-modules => mounted", this.$rootElementComponent);

		if (this.activated == "true") {
			this.showHelp(this.dataid, 1);
		}
		history.scrollRestoration = "manual";
		// window.location.href = '#app';

		// console.log('params', this.getParams(window.location.href));
		this.params = this.getParams(window.location.href);
		if (this.params.id && this.activated !== "true") {
			this.paramsArray = this.params.id.split("/");
			this.active = this.paramsArray[0];
			this.showHelp(this.paramsArray[0], 1, true);
		}
	},
	updated() {
		// console.log("help-modules => updated", this.$rootElementComponent);

		if (this.$rootElementComponent) {
			sForm.initSend(this.$rootElementComponent);
			formInputs.init(
				this.$rootElementComponent.querySelectorAll("input, textarea")
			);
			attachments.init(this.$rootElementComponent);
			dAction.init(this.$rootElementComponent);

			eDropdown.init(this.$rootElementComponent);
			dropdownAnimation.offerDropdown(this.$rootElementComponent);
			bindTooltip(this.$rootElementComponent);
			slideFaq(this.$rootElementComponent);
			$(this.$rootElementComponent).find("[type=tel]").mask("000000000");
		}
		// detectFilledFields();
		// bindTooltip();

		toggleBox.toggle({
			targetClassName: "contactAcceptances",
			parentClassName: "contact-box__approvals",
			contentClassName: "contactApprovalsContent",
			state: "showHide",
		});
		approvals.acceptAll(
			"totalCheck",
			"contact-box__approvals",
			"contactApprovalsContent"
		);

		if (this.scroll) {
			let hrefElement;
			if (this.params.scroll) {
				hrefElement = document.querySelector(
					"[data-scroll=" + this.params.scroll + "]"
				);
			} else if (this.paramsArray[this.paramsArray.length - 1]) {
				hrefElement = document.querySelector(
					"[data-id=" + this.paramsArray[this.paramsArray.length - 1] + "]"
				);
			}

			if (hrefElement) {
				document.documentElement.scrollTop = this.getOffsetTop(hrefElement) - 140;
				if (document.scrollingElement)
					document.scrollingElement.scrollTop = this.getOffsetTop(hrefElement) - 140;
			}
			this.scroll = false;
		}

		// scroll
		if (this.result_changed) {
			const tiles = this.$el.querySelectorAll(".help-app-tiles");
			const elements = this.$el.querySelectorAll(".help-app-elements");

			let act_el = tiles[0];

			if (elements.length == 0 && tiles.length > 1) {
				act_el = tiles[tiles.length - 1];
			}
			if (elements.length > 0 && tiles.length > 0) {
				act_el = elements[0];
			}
			if ($(act_el).offset()) {
				$("html, body")
					.animate(
						{
							scrollTop: $(act_el).offset().top - $(window).height() * 0.3,
						},
						300
					)
					.promise()
					.then(function () {
						// console.log('runs once!')
						act_el.tabIndex = -1;
						act_el.focus();
						act_el.addEventListener("focusout", () => {
							act_el.removeAttribute("tabindex");
						});
					});
			}

			this.result_changed = false;
		}

		// GA events
		if (this.$rootElementComponent) {
			const gaLeadForms =
				this.$rootElementComponent.querySelectorAll("[data-ga-param]");
			if (gaLeadForms) {
				gaLeadForms.forEach((form) => {
					const param = form.getAttribute("data-ga-param");
					const inputs = form.querySelectorAll(
						"input[type=tel], input[type=email], input[type=text]"
					);

					//form view
					this.gaFormView(form, param);
					document.addEventListener("scroll", () => {
						this.gaFormView(form, param);
					});

					//form filling start
					inputs.forEach((input) => {
						input.addEventListener("input", () => {
							if (input.value !== "") {
								this.gaFormFilling(param);
							}
						});
					});
				});
			}
		}
		const leadform_recaptcha = document.querySelectorAll("#leadform_recaptcha");
		if (leadform_recaptcha) {
			leadform_recaptcha.forEach((recaptcha) => {
				if (!recaptcha.childNodes.length) {
					window["leadform_recaptcha_" + recaptcha.getAttribute("data-form-id")] =
						grecaptcha.render(recaptcha, {
							sitekey: recaptcha.getAttribute("data-sitekey"),
							callback: function () {
								const recaptchaLeadformError = form.querySelector(
									"#leadform_recaptchaError"
								);
								if (recaptchaLeadformError.classList.contains("is-shown")) {
									recaptchaLeadformError.classList.remove("is-shown");
								}
							},
						});
				}
			});
		}
	},
	watch: {
		res_data() {
			this.result_changed = true;
		},
	},
	// computed: {
	// 	fullName: function () {
	// 	  return this.firstName + ' ' + this.lastName
	// 	}
	// },
	template: "#help-modules",
	methods: {
		showHelp: function (id, level, callback, guid) {
			if (document.querySelector("[data-id=" + id + "]") && !guid) {
				guid = document.querySelector("[data-id=" + id + "]").getAttribute("id");
			}
			if (level === 1) {
				this.active = id;
			}
			// console.log('showHelp id', id);
			// console.log('this.active', this.active);

			this.$root.showLoader = true;
			const urlParams = this.buildUrl(id, level);
			if (this.activated !== "true") {
				history.pushState(null, null, urlParams);
			}

			requestHelper
				.request(
					this.$refs.helpModules.getAttribute("method"),
					this.$refs.helpModules.getAttribute("data-url") +
						"?id=" +
						id +
						"&guid=" +
						guid,
					id
				)
				.then((res) => {
					res = JSON.parse(res);
					// console.log(level, typeof(level));
					this.res_data = res;
					if (level === 1) {
						this.results = res;
						this.results2 = {};
						this.results3 = {};
					}
					if (level === 2) {
						this.results2 = res;
						this.results3 = {};
					}
					if (level === 3) {
						this.results3 = res;
					}

					if (callback && level < this.paramsArray.length) {
						level++;
						if (level > 1) {
							if (res.tiles) {
								for (var i = 0; i < res.tiles.length; i++) {
									if (res.tiles[i].data_id === this.paramsArray[level - 1]) {
										guid = res.tiles[i].id;
									}
								}
							}
						}
						this.showHelp(this.paramsArray[level - 1], level, true, guid);
					}
					if (callback && level === this.paramsArray.length) {
						this.scroll = true;
					}
					this.$rootElementComponent = this.$el;
					this.$root.showLoader = false;
				})
				.catch((e) => {
					console.log(e);
					this.$root.showLoader = false;
				});
		},
		buildUrl: function (id, level) {
			let actualUrl = window.location.href;
			let url = actualUrl;
			let idIndex = actualUrl.indexOf("id=");
			if (level === 1) {
				this.idValue = [id, "", ""];
			} else if (level === 2) {
				this.idValue[1] = id;
				this.idValue[2] = "";
			} else {
				this.idValue[2] = id;
			}
			this.idValueString = this.idValue.toString();
			this.idValueString = this.idValueString.split(",").join("/");
			for (let i = 0; i < 2; i++) {
				if (this.idValueString.charAt(this.idValueString.length - 1) === "/") {
					this.idValueString = this.idValueString.substring(
						0,
						this.idValueString.length - 1
					);
				}
			}

			if (actualUrl.indexOf("?") > -1) {
				if (idIndex > -1) {
					actualUrl = actualUrl.substring(idIndex + 3, actualUrl.length);
					if (actualUrl.indexOf("&") > -1) {
						actualUrl = actualUrl.substring(0, actualUrl.indexOf("&"));
					}
					url = url.replace(actualUrl, this.idValueString);
				} else {
					url += "&id=" + this.idValueString;
				}
			} else {
				url += "?id=" + this.idValueString;
			}

			return url;
		},
		getParams: function (url) {
			var params = {};
			var parser = document.createElement("a");
			parser.href = url;
			var query = parser.search.substring(1);
			var vars = query.split("&");
			for (var i = 0; i < vars.length; i++) {
				var pair = vars[i].split("=");
				params[pair[0]] = decodeURIComponent(pair[1]);
			}
			return params;
		},
		showHelpEmit: function (obj) {
			this.showHelp(obj.id, obj.level, false, obj.guid);
		},
		currentComponent: function (type) {
			if (type) {
				return "contact-help-" + type;
			}
		},
		getOffsetTop: function (elem) {
			if (elem) {
				var offsetTop = 0;
				do {
					if (!isNaN(elem.offsetTop)) {
						offsetTop += elem.offsetTop;
					}
				} while ((elem = elem.offsetParent));
				return offsetTop;
			}
		},
		gaFormView: function (form, param) {
			if (isInViewport(form)) {
				if (!this.viewed) {
					this.sendGaEvent("leadform", "view", param);
					this.viewed = true;
				}
			}
		},
		gaFormFilling: function (param) {
			if (!this.filled) {
				this.sendGaEvent("leadform", "start", param);
				this.filled = true;
			}
		},
		sendGaEvent: function (eventType, param1, param2) {
			dataLayer.push({
				event: eventType,
				eventParam1: param1,
				eventParam2: param2,
			});
		},
	},
});
